import React from 'react';

import i18n from 'util/i18n';
import { MILITARY } from 'config/formSections/military';

import SectionIntro from 'components/Section/shared/SectionIntro';
import { isPVQForm } from 'helpers/form';
import { rootSelectors } from '@redux/modules/selectors';
import { useSelector } from 'react-redux';

const Intro = function () { // eslint-disable-line func-names
  const formType = useSelector(rootSelectors.application.getFormType);
  const isPVQ = isPVQForm(formType);

  return isPVQ ? (
    <SectionIntro
      title={i18n.t('military.pvq.intro.title')}
      body={i18n.m('military.pvq.intro.body')}
      sectionKey={MILITARY.key}
    />

  ) : (

    <SectionIntro
      title={i18n.t('military.intro.title')}
      body={i18n.m('military.intro.body')}
      sectionKey={MILITARY.key}
    />
  );
};

export default Intro;
